export default {
    props: {
        number: Number,
    },
    template: `
      <strong
          v-if="Number.isInteger(number) && number > 0"
          class="badge-filter rounded px-50 small py-15 text-white ms-25 bg-primary t-n1"
      >{{number}}</strong>
    `
}
